var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pd-y-30"},[_c('div',{staticClass:"container",staticStyle:{"max-width":"600px !important"}},[_c('div',{staticClass:"section-title"},[_c('h2',[_vm._v(_vm._s(_vm.comp.task))]),_c('p',[_vm._v(_vm._s(_vm.comp.f1))])])]),_c('div',{staticClass:"container"},[_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.tasks),function(t,i){return _c('li',{key:i,staticClass:"media d-block d-sm-flex"},[_c('router-link',{attrs:{"to":{
            name: _vm.$store.state.app.activeGroup.publicPage.route,
            params: {
              id: _vm.$store.state.app.contentPageId,
              cid: t.id
            }
          }}},[_c('img',{staticClass:"wd-100p wd-sm-200 rounded mg-sm-r-20 mg-b-20 mg-sm-b-0",attrs:{"src":((t.defaultAttachmentUrl) + "?w=460&h=360&mode=crop"),"alt":""}})]),_c('div',{staticClass:"media-body"},[_c('h5',{staticClass:"mg-b-10 tx-inverse"},[_c('router-link',{attrs:{"to":{
                name: _vm.$store.state.app.activeGroup.publicPage.route,
                params: {
                  id: _vm.$store.state.app.contentPageId,
                  cid: t.id
                }
              }}},[_vm._v(_vm._s(t.task))])],1),_vm._v(" "+_vm._s(t.f1)+" "),_c('div',{staticClass:"text-orange"},[_c('router-link',{attrs:{"to":{
                name: _vm.$store.state.app.activeGroup.publicPage.route,
                params: {
                  id: _vm.$store.state.app.contentPageId,
                  cid: t.id
                }
              }}},[_vm._v(_vm._s(_vm._f("moment")(t.createdDate,"YYYY.MM.DD")))])],1)])],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }